"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
// 活动回显逻辑抽离
/**
 * 涉及页面(添加需标记)
 * 1.首页搜索页面管理
 *
 */
var _default = exports.default = {
  methods: {
    /**
     * 可扩展返回值
     * @param {data} 传入的对象
     * @param {name} 返回的活动name
     * @param {openUrl} 返回的活动链接
     */
    response: function response(data) {
      var name;
      var openUrl = data.openUrl;
      if (data.Display_type === 1 || data.Display_type === 2) {
        // 自定义活动，官方活动 回填
        name = data.name;
      } else if (data.Display_type === 3) {
        // 聚合页活动回填
        name = data.name;
      } else if (data.Display_type === 4) {
        // 通用H5活动 回填
        name = data.name;
      } else if (data.Display_type === 5) {
        name = data.title;
      } else if (data.Display_type === 6) {
        name = data.activityName;
      } else if (data.Display_type === 7) {
        // 第三方 代下单  回填
        name = data.name;
      } else if (data.Display_type === 8) {
        name = data.activityName;
      } else if (data.Display_type === 9) {
        name = data.activityName;
      }
      return {
        name: name,
        openUrl: openUrl
      };
    }
  }
};